export const SERVER = process.env.REACT_APP_SERVER ?? 'http://localhost:8000'
export const KEY_SERVER = `${SERVER}/build/`
export const NUM_EPOCH_KEY_NONCE_PER_EPOCH = 3
export const CHECKED_IN_AT = 'checked-in-at'
export const DISCARDED_CHECK_IN_AT = 'discarded-check-in-at'
